import styled from '@emotion/styled'

const StyledContainer = styled.div`
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border: 1px solid transparent;
  display: flex;
  flex-direction: column;
`
const StyledTitle = styled.div`
  font-weight: 500;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.9);
`
const StyledHeader = styled.div`
  border-bottom: 1px solid #e7e7e7;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const StyledContent = styled.div`
  flex: 1;
  height: 100%;
  padding: ${({ contentPadding }) => {
    return contentPadding || '24px 32px'
  }};
  max-height: ${({ isFullScreen, maxHeight }) => {
    return isFullScreen ? '100%' : maxHeight || '30rem'
  }};
  overflow-y: auto;
`
const StyledFooter = styled.div`
  width: 100%;
  padding: 12px 16px;
  height: 56px;
  border-top: 1px solid #dbdfea;
  .footer-box {
    display: flex;
    justify-content: flex-end;
  }
`
const StyleIcon = styled.div`
  cursor: pointer;
`

export {
  StyledContainer,
  StyledContent,
  StyledTitle,
  StyledHeader,
  StyledFooter,
  StyleIcon,
}
